export default __webpack_public_path__ + "static/media/map_thumb.afb7d7f9.png";